<template>
    <div>
        <b-row class="text-justify mb-3">
            <b-col cols="6" lg="3">
                <span>Data de Adjudicação: </span>
                <span>{{ licitacao.DtAdjudicacao?.toLocaleDateString() }}</span>
            </b-col>
            <b-col cols="6" lg="3">
                <span>Homologação Parcial: </span>
                <span>{{ licitacao.FlHomologParcial }}</span>
            </b-col>
            <b-col cols="6" lg="3">
                <span>Data de Homologação/Ratificação: </span>
                <span>{{ licitacao.DtHomologacao?.toLocaleDateString() }}</span>
            </b-col>
            <b-col v-if="temArquivoAta" cols="6" lg="3">
                <span>Baixar Ata de Abertura/Julgamento (PDF) *</span>
                <div class="wrapper-icon">
                    <btn-download :fazerDownload="baixarAnexo" :texto="''" />
                </div>
            </b-col>
        </b-row>
        <b-row class="text-justify mb-3">
            <detalhes-vencedores-lote-table v-if="isLote"
                :idLicitacao="licitacao.IdLicitacao"></detalhes-vencedores-lote-table>
            <detalhes-vencedores-item-table v-else :idLicitacao="licitacao.IdLicitacao"></detalhes-vencedores-item-table>
        </b-row>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

import DetalhesVencedoresLoteTable from '@/components/licitacoes/ldi/DetalhesVencedoresLoteTable.vue'
import DetalhesVencedoresItemTable from '@/components/licitacoes/ldi/DetalhesVencedoresItemTable.vue'
import BtnDownload from '@/components/shared/btn-download.vue'
import ldiService from '@/services/licitacoes/ldiService'

const CompProps = Vue.extend({
    name: 'DetalhesVencedores',
    components: { DetalhesVencedoresLoteTable, DetalhesVencedoresItemTable, BtnDownload },
    props: {
        licitacao: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class DetalhesVencedores extends mixins(UtilsTS, CompProps) {
    //computed
    get isLote(): boolean {
        return this.licitacao.IsLote
    }

    get temArquivoAta(): boolean {
        return !!this.licitacao.ArquivoAta
    }

    async baixarAnexo() {
        const arquivo = this.licitacao.ArquivoAta
        const response = await ldiService.baixarAnexo(arquivo?.IdArquivo)
        this.download(`ata-${this.licitacao.NumeroAnoLicitacao}`, response.data)
    }
}
</script>

<style scoped>
div.row>div>span:first-child {
    font-weight: bolder;
    display: block;
}
</style>